import React, { FC } from 'react';

import { Box, Copy24 } from 'Modules/ui3';


interface CopyProps {
    value: string;
}

export const CopyButton: FC<CopyProps> = ({ value }) => {
    const handleCopy = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
        window.navigator.clipboard.writeText(value);
    };
    return (
        <Box
            onClick={e => handleCopy(e)}
            color='grayscale.shade80'
            sx={{ cursor: 'pointer' }}
        >
            <Copy24 sx={{ fontSize: 16 }} />
        </Box>
    );
};
